import TripAddToCalendar from './trip-add-to-calendar-component';
import TripAddToCalendarService from './trip-add-to-calendar-service';

import './trip-add-to-calendar.scss';

const MODULE_NAME = 'app.trip.add-to-calendar';
const module = angular.module(MODULE_NAME, [])
    .directive(TripAddToCalendar.DIRECTIVE_NAME, TripAddToCalendar)
    .service('tripAddToCalendarService', TripAddToCalendarService);

export {module, MODULE_NAME as default};



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-add-to-calendar/trip-add-to-calendar-module.js